import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  MenuItem,
  Select,
  Button,
  FormControl,
  TablePagination,
  Chip,
  Typography,
  Tooltip,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { blogscoverurl } from "../../../../Apis/Api";
import deletelogo from "../../../../Utils/Logos/deleteuser.png";
import editlogo from "../../../../Utils/Logos/edit.png";
import { GetAllCategory, GetallBlogs } from "../../../../Redux/Slices/Resources/Resources.action";
import { useNavigate } from "react-router-dom";
import DeleteResources from "../../../../Components/Popups/DeleteResources";
import EditBlogPopup from "../../../../Components/Popups/EditBlogPopup";
import TostContainer from "../../../../Components/Alerts/TostContainer";
const Blogspage = () => {
  const columns = [
    { id: "#", label: "#" },
    { id: "Image", label: "Image " },
    { id: "Category", label: "Category " },
    { id: "Blogs Name", label: "Blogs Name" },
    // { id: "Price", label: "Price" },
    { id: "Action", label: "Action" },
  ];

  let dispatch = useDispatch();
  let blogsdata = useSelector((store) => store?.Resources);
  let navigate = useNavigate();
  let addblog = () => {
    navigate("/dashboard/resources/blogs/addblogs");
  };
  let [filteredvalue,setfilteredvalue]=useState(0)
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  useEffect(() => {
    dispatch(GetAllCategory())
    dispatch(GetallBlogs({value:filteredvalue,count:page * rowsPerPage,row_count: rowsPerPage}));
  }, [dispatch, page, rowsPerPage]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    dispatch(GetallBlogs({value:filteredvalue,count:page * rowsPerPage,row_count: rowsPerPage}));
  };
  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };
  const getfilterdvalue = (value) => {
    setPage(0);
    setfilteredvalue(value)
    dispatch(GetallBlogs( {value:value,count:page * rowsPerPage,row_count: rowsPerPage}));
  }
  let resourcetype = "blogs";
  let [deleteselected, setdeleteselected] = useState({});
  let [isdeleteresource, setisdeleteresource] = useState();
  let openresorcedelete = (data) => {
    setdeleteselected(data);
    setisdeleteresource(true);
  };
  let closedeleteresource = () => {
    setisdeleteresource(false);
  };
  let [editfiledata, seteditfiledata] = useState({});
  let [iseditblogpopup, setiseditpopup] = useState(false);
  let openeditpopup = (data) => {
    seteditfiledata(data);
    setiseditpopup(true);
  };
  let closeeditpopup = () => {
    setiseditpopup(false);
  }
  let Rowdata =  blogsdata?.BlogFiles?.r?.map((data, i) => ({
    rowid: i + 1 + page * 10,
    ...data,
  }))
  return (
    <>
      <TostContainer />
      {iseditblogpopup ? (
        <EditBlogPopup
          modalcontrols={{
            iseditblogpopup,
            closeeditpopup,
            editfiledata,
            value:filteredvalue,count:page * rowsPerPage,row_count: rowsPerPage
          }}
        />
      ) : (
        ""
      )}

      {isdeleteresource ? (
        <DeleteResources
          modalcontrols={{
            isdeleteresource,
            closedeleteresource,
            resourcetype,
            deleteselected,
            value:filteredvalue,count:page * rowsPerPage,row_count: rowsPerPage
          }}
        />
      ) : (
        ""
      )}

      <Box
        sx={{
          width: "100%",
          height: "40px",
          display: "flex",
          justifyContent: "space-between",
          mt: "15px",
        }}
      >
        <Box
          sx={{
            width: "20%",
            height: "20%",
            display: "flex",
            alignItems: "center",
            background: "rgba(246, 133, 130, 0.50)",
          }}
        >
          <FormControl sx={{ width: "100%", height: "100%" }} size="small">
            <Select
              sx={{
                width: "100%",
                height: "60px",
                border: "1px solid #F68582",
                background: "#fff",
              }}
              labelId="demo-select-small-label"
              id="demo-select-small"
              label="All"
              onChange={(e) => getfilterdvalue(e.target.value)}
              defaultValue={0} // Set the value corresponding to "All" as the default value
            >
                <MenuItem value={0}>All</MenuItem>
              {blogsdata?.CategoryList?.map((el)=>
              <MenuItem value={el?.id}>{el?.name} </MenuItem>
              )}
            </Select>
          </FormControl>
        </Box>

        <Button
          onClick={addblog}
          sx={{
            padding: "5px 40px",
            textTransform: "capitalize",
            color: "#000",
            boxShadow:
              "2px 2px 8px 0px rgba(143, 95, 11, 0.50), 0px 3px 11.111px 0px #FBB15A inset, 0px -11px 11.111px 0px #D68835 inset",
            background: " linear-gradient(180deg, #FFCE98 0%, #F4AA50 100%);",
          }}
        >
          Add More
        </Button>
      </Box>
      <Box sx={{ mt: "20px" }}>
        <Paper style={{ width: "100%", overflow: "hidden" }}>
          <TableContainer style={{ maxHeight: "71vh" }}>
            <Table stickyHeader sx={{}}>
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      sx={{
                        textAlign: "center",
                        fontSize: "15px",
                        lineHeight: "120%",
                        fontFamily: "Montserrat",
                        fontWeight: "600",
                        background: "#F68582",
                        color: "#fff",
                      }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {Rowdata?.length < 1 || blogsdata?.BlogFiles?.r==null ? (
                  <Box sx={{ textAlign: "center", padding: "10px", m: "10px" }}>
                    No Data
                  </Box>
                ) : (
                  Rowdata?.map((row, i) => (
                    <TableRow key={row.id} sx={{ textAlign: "center" }}>
                      <TableCell sx={{ textAlign: "center" }}>
                       {row?.rowid}
                      </TableCell>
                      <TableCell sx={{ textAlign: "center" }}>
                        {" "}
                        <img
                          src={` ${blogscoverurl}/${row?.cover_img}`}
                          style={{
                            height: "40px",
                            width: "50px",
                            borderRadius: "10px",
                          }}
                          alt=""
                        />
                      </TableCell>
                      <TableCell sx={{ textAlign: "center" }}>
                        <Tooltip
                          sx={{ backgroundColor: "red" }}
                          title={
                            <Box>
                              {row?.category?.map((item, index) => (
                                <Typography
                                  sx={{ fontSize: "14px" }}
                                  key={index}
                                >
                                  {item?.name}
                                </Typography>
                              ))}
                            </Box>
                          }
                        >
                          <Typography
                            noWrap
                            sx={{
                              width: "100px",
                              display: "flex",
                              m: "auto",
                              textOverflow: "ellipsis",
                              cursor: "pointer",
                              justifyContent:"center",
                              textAlign:"center"
                            }}
                          >
                            {row?.category[0]?.name} , {row?.category[1]?.name} {row?.category?.length<2?"":<span>....</span>} 
                            {/* {row?.category?.map((item, index) => (
                            <Typography sx={{ fontSize: "14px" }} key={index}>
                              {item?.name} ,
                            </Typography>
                          ))} */}
                          </Typography>
                        </Tooltip>
                      </TableCell>
                      <TableCell sx={{ textAlign: "center" }}>
                        {" "}
                        {row?.title}
                      </TableCell>
                      {/* <TableCell sx={{ textAlign: "center" }}>
                        {" "}
                        {row?.price == 0 ? (
                          <Chip
                            label="Free"
                            color="success"
                            variant="outlined"
                          />
                        ) : (
                          <Typography>${row?.price}</Typography>
                        )}
                      </TableCell> */}

                      <TableCell
                        sx={{ display: "flex", justifyContent: "center" }}
                      >
                        <Box
                          sx={{
                            height: "50px",
                            display: "flex",
                            gap: "20px",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <img
                            onClick={() => openresorcedelete(row)}
                            style={{
                              width: "30px",
                              height: "30px",
                              cursor: "pointer",
                            }}
                            src={deletelogo}
                            alt=""
                          />

                          <img
                            onClick={() => openeditpopup(row)}
                            style={{
                              width: "30px",
                              height: "30px",
                              cursor: "pointer",
                            }}
                            src={editlogo}
                            alt=""
                          />
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        <Box>
          <TablePagination
            sx={{ mb: "-20px" }}
            component="div"
            count={blogsdata?.BlogFiles?.count || 0}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            // rowsPerPage={10}
            // rowsPerPageOptions={[]}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Box>
      </Box>
    </>
  );
};

export default Blogspage;
